import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CacheService } from '../../../../../projects/common/src/app/services/cache.service';
import { IOutputFilter } from '../../core/interfaces/output-filter';
import { catchError } from 'rxjs/operators';
import { throwError, Observable } from 'rxjs';
import { CommunicationService } from '../../../services/communication/communication.service';
import { Logger } from '../../../../../projects/common/src/app/classes/logger';
import { UrlBuilderService } from 'projects/communication/src/app/services';

@Injectable({
  providedIn: 'root',
})
export class ReportCasService extends Logger {
  constructor(
    private cacheService: CacheService,
    private http: HttpClient,
    private communicationService: CommunicationService,
    private urlBuilder: UrlBuilderService,
  ) {
    super();
  }

  /**
   * Function to get filtered result for cas report by selected filters
   *
   * @param selectedFilters Filters selected by user to get data
   */
  public getCas(selectedFilters): Observable<any> {
    const params = this.setParams(selectedFilters);
    const url = `${this.urlBuilder.apiUrl}/Report/GetAlarmNotification?`;
    return this.http.get(url, { params, responseType: 'json' }).pipe(catchError((err) => throwError(() => err.error)));
  }

  /**
   * Get excel from GetChecklistReportDetailDocument endpoint
   */
  public getCasExcel(selectedFilters): Observable<any> {
    const url = `${this.urlBuilder.apiUrl}/Report/GetAlarmNotificationdocument?`;
    const params = this.setParams(selectedFilters);
    return this.http.get(url, { params, responseType: 'blob' }).pipe(catchError((err) => throwError(() => err.error)));
  }

  /**
   * Function to set params and send selected filters to request
   *
   * @param selectedFilters Filters selected to save params
   */
  private setParams(selectedFilters: IOutputFilter): any {
    const companyId = this.cacheService.local('session').user.company.id;

    return {
      startDate: selectedFilters.startDate,
      machineTypeId: selectedFilters.machineTypeId,
      machineId: selectedFilters.machineId,
      operatorId: selectedFilters.operatorId,
      companyId,
    };
  }

  /**
   * Handle error
   *
   * @param err error
   */
  private handleError(err: any): Observable<any> {
    this.error(err);
    return throwError(err);
  }
}
